import type { AxiosProgressEvent, AxiosResponse, CancelToken } from "axios";

import type { IApiResponse } from "..";
import { axiosClient } from "..";

export type IUploadFileResponseType = AxiosResponse<IApiResponse<string>>;

export function uploadFileAPI(
  data: FormData,
  progressCallBack?: (progressEvent: AxiosProgressEvent) => void,
  cancelToken?: CancelToken,
): Promise<IUploadFileResponseType> {
  return axiosClient.post("/files", data, {
    onUploadProgress(progressEvent) {
      progressCallBack?.(progressEvent);
    },
    cancelToken,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
